import {metadaApi} from '@dms/api/base';

import {
  CheckoutArticleUpdateJobBasketRequest,
  CheckoutArticleUpdateJobBasketRequestSchema,
  CheckoutArticleUpdateJobBasketResponse,
  CheckoutArticleUpdateJobBasketResponseSchema,
  DeleteArticleUpdateJobItemsRequest,
  DeleteArticleUpdateJobItemsRequestSchema,
  DeleteArticleUpdateJobItemsResponse,
  DeleteArticleUpdateJobItemsResponseSchema,
  DiscardArticleUpdateJobBasketRequest,
  DiscardArticleUpdateJobBasketRequestSchema,
  DiscardArticleUpdateJobBasketResponse,
  DiscardArticleUpdateJobBasketResponseSchema,
  GetArticleUpdateJobBasketRequest,
  GetArticleUpdateJobBasketRequestSchema,
  GetArticleUpdateJobBasketResponse,
  GetArticleUpdateJobBasketResponseSchema,
  PostArticleUpdateJobBasketItemsRequest,
  PostArticleUpdateJobBasketItemsRequestSchema,
  PostArticleUpdateJobBasketItemsResponse,
  PostArticleUpdateJobBasketItemsResponseSchema,
} from './types';

export const metadaWarehouseArticleUpdateJobBasketApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getArticleUpdateJobBasket: build.query<
      GetArticleUpdateJobBasketResponse,
      GetArticleUpdateJobBasketRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/article-update-job/${queryArg.articleUpdateJobId}/basket`,
        method: 'GET',
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'articleUpdateJobBasket', id: queryArg.articleUpdateJobId},
      ],
      extraOptions: {
        requestSchema: GetArticleUpdateJobBasketRequestSchema,
        responseSchema: GetArticleUpdateJobBasketResponseSchema,
      },
    }),
    checkoutArticleUpdateJobBasket: build.mutation<
      CheckoutArticleUpdateJobBasketResponse,
      CheckoutArticleUpdateJobBasketRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/article-update-job/${queryArg.articleUpdateJobId}/basket-checkout`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'articleUpdateJobBasket', id: queryArg.articleUpdateJobId},
        {type: 'articleUpdateJobs', id: queryArg.articleUpdateJobId},
      ],
      extraOptions: {
        requestSchema: CheckoutArticleUpdateJobBasketRequestSchema,
        responseSchema: CheckoutArticleUpdateJobBasketResponseSchema,
      },
    }),
    discardArticleUpdateJobBasket: build.mutation<
      DiscardArticleUpdateJobBasketResponse,
      DiscardArticleUpdateJobBasketRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/article-update-job/${queryArg.articleUpdateJobId}/basket/discard`,
        method: 'PATCH',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'articleUpdateJobBasket', id: queryArg.articleUpdateJobId},
        {type: 'articleUpdateJobs', id: queryArg.articleUpdateJobId},
      ],
      extraOptions: {
        requestSchema: DiscardArticleUpdateJobBasketRequestSchema,
        responseSchema: DiscardArticleUpdateJobBasketResponseSchema,
      },
    }),
    postArticleUpdateJobBasketItems: build.mutation<
      PostArticleUpdateJobBasketItemsResponse,
      PostArticleUpdateJobBasketItemsRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/article-update-job/${queryArg.articleUpdateJobId}/basket-add-item`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'articleUpdateJobBasket', id: queryArg.articleUpdateJobId},
      ],
      extraOptions: {
        requestSchema: PostArticleUpdateJobBasketItemsRequestSchema,
        responseSchema: PostArticleUpdateJobBasketItemsResponseSchema,
      },
    }),
    deleteArticleUpdateJobItems: build.mutation<
      DeleteArticleUpdateJobItemsResponse,
      DeleteArticleUpdateJobItemsRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/article-update-job/${queryArg.articleUpdateJobId}/item/delete`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'articleUpdateJobBasket', id: queryArg.articleUpdateJobId},
        {type: 'articleUpdateJobs', id: queryArg.articleUpdateJobId},
      ],
      extraOptions: {
        requestSchema: DeleteArticleUpdateJobItemsRequestSchema,
        responseSchema: DeleteArticleUpdateJobItemsResponseSchema,
      },
    }),
  }),
});

export const {
  useGetArticleUpdateJobBasketQuery,
  useCheckoutArticleUpdateJobBasketMutation,
  useDiscardArticleUpdateJobBasketMutation,
  usePostArticleUpdateJobBasketItemsMutation,
  useDeleteArticleUpdateJobItemsMutation,
} = metadaWarehouseArticleUpdateJobBasketApi;
